<template>
    <template v-if="type === 'item'">
        <li class="ds-pagination__item" :class="{ 'ds-pagination__item--hide-xs': hideOnXs }">
            <button
                @click="onClickHandler(pageNumber)"
                class="button button--sm button--secondary"
                :class="{ 'button--dark': theme === 'dark' }"
                :aria-label="`Přejít na stránku ${pageNumber}`"
            >
                {{ pageNumber }}
            </button>
        </li>
    </template>

    <template v-else-if="type === 'activeItem'">
        <li class="ds-pagination__item ds-pagination__item--active" aria-current="page">
            <span>{{ pageNumber }}</span>
        </li>
    </template>

    <template v-else-if="type === 'dots'">
        <li class="ds-pagination__item ds-pagination__link-dots">
            <span class="ds-pagination__dots">...</span>
        </li>
    </template>
</template>

<script lang="ts" setup>
import { inject } from "vue";
import type { Theme } from "../types/theme";
import { themeKey } from "../pagination/pagination-injection-key";

const theme = inject<Theme>(themeKey);

defineProps<{
    type: "item" | "activeItem" | "dots";
    pageNumber?: number;
    hideOnXs?: boolean;
    onClickHandler?: (pageNumber: number) => void;
}>();
</script>
